import AssistanceCardsPage from './AssistanceCardsPage';

export default AssistanceCardsPage;
